/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_External_Writes_DescriptionInputs */



/**
* | output |
* | --- |
* | "When on, autonomous agents may perform external writes, such as creating an invoice, without human approval. Actions oneAI recognises as irreversible are rel..." |
*
* @param {Agent_Policy_External_Writes_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_external_writes_description = /** @type {((inputs?: Agent_Policy_External_Writes_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_External_Writes_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn aktiviert, dürfen autonome Agenten externe Schreibvorgänge wie das Erstellen einer Rechnung ausführen, ohne dass ein Mensch zustimmt. Aktionen, die oneAI als unumkehrbar erkennt, gibt stattdessen die Einstellung darunter frei; ein Aufruf, der beides mischt, braucht beide. Wenn deaktiviert (empfohlen), pausiert jeder externe Schreibvorgang und wartet auf eine Freigabe.")
	return /** @type {LocalizedString} */ ("When on, autonomous agents may perform external writes, such as creating an invoice, without human approval. Actions oneAI recognises as irreversible are released by the setting below instead; a call that mixes both needs both. When off (recommended), every external write pauses for an approver.")
});